import React, { useState } from "react";
import { X, Eye, Mail, CheckCircle2, ShieldCheck, Loader2 } from "lucide-react";
import { api, formatApiError } from "../api/client";
import { toast } from "sonner";

export const ProAccessModal = ({ open, onClose, source = "upgrade_modal", interest = null }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/beta-leads", { email, source, interest });
      setDone(true);
      toast.success("Añadido a la lista prioritaria");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail("");
    setDone(false);
    onClose();
  };

  return (
    <div
      data-testid="pro-access-modal"
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/80 backdrop-blur-md p-4 overflow-y-auto"
      onClick={handleClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md bg-[#0A0A0A] border border-[#DEFF9A]/30 rounded-2xl p-6 sm:p-8 my-auto glow-acid"
      >
        <button
          data-testid="pro-access-close-btn"
          onClick={handleClose}
          className="absolute top-4 right-4 text-[#5A5F68] hover:text-white transition-colors"
        >
          <X size={20} />
        </button>

        {!done ? (
          <>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-lg bg-[#DEFF9A]/10 border border-[#DEFF9A]/30 flex items-center justify-center">
                <Eye size={20} className="text-[#DEFF9A]" />
              </div>
              <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#DEFF9A]">
                ScanEye Professional
              </span>
            </div>

            <h2 className="font-display text-3xl font-black tracking-tighter mb-3 leading-tight">
              Acceso a ScanEye Professional
            </h2>
            <p className="text-[#8A8F98] text-sm leading-relaxed mb-6">
              Estamos activando nuestros <span className="text-white">nodos de certificación judicial</span>.
              Deja tu email para recibir <span className="text-[#DEFF9A]">acceso prioritario</span> y un{" "}
              <span className="text-[#DEFF9A] font-semibold">50% de descuento</span> en tu primer informe pericial.
            </p>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div className="relative">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5A5F68]" />
                <input
                  data-testid="pro-access-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@empresa.com"
                  className="se-input w-full bg-[#141414] border border-[#1F2428] rounded-lg pl-11 pr-4 py-3 text-white placeholder:text-[#5A5F68] outline-none transition-all"
                />
              </div>
              <button
                data-testid="pro-access-submit-btn"
                type="submit"
                disabled={loading}
                className="w-full bg-[#DEFF9A] hover:bg-[#C8FF6E] text-black font-bold rounded-lg py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                {loading ? "Enviando..." : "Reservar acceso prioritario"}
              </button>
            </form>

            <div className="mt-5 flex items-start gap-2 p-3 rounded-lg bg-[#141414] border border-[#1F2428]">
              <ShieldCheck size={14} className="text-[#DEFF9A] flex-shrink-0 mt-0.5" />
              <p className="text-[11px] text-[#8A8F98] leading-relaxed">
                Invitaciones escalonadas · Sin spam · Puedes darte de baja en cualquier momento.
              </p>
            </div>
          </>
        ) : (
          <div className="py-6 text-center">
            <div className="w-14 h-14 rounded-full bg-[#DEFF9A]/20 border border-[#DEFF9A]/50 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 size={28} className="text-[#DEFF9A]" />
            </div>
            <h3 className="font-display text-2xl font-black mb-2">Estás en la lista</h3>
            <p className="text-[#8A8F98] text-sm max-w-xs mx-auto">
              Recibirás tu invitación de acceso prioritario y el cupón del 50% antes de activar nodos.
            </p>
            <button
              onClick={handleClose}
              className="mt-6 text-[#DEFF9A] hover:text-white text-sm font-mono uppercase tracking-[0.2em] transition-colors"
            >
              Cerrar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
